import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { takEntitiesKeys } from './queryKeys';
import type { ListTakEntitiesResponse } from './types';

// Matches the pratus-tak ingest daemon's 15s poll cadence.
const TAK_REFETCH_INTERVAL_MS = 15_000;

export const useListTakEntitiesQuery = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: takEntitiesKeys.list(),
    queryFn: async () => {
      const resp = await axios.get<ListTakEntitiesResponse>(
        config.apiGateway.tak_entities
      );
      return resp.data;
    },
    refetchInterval: TAK_REFETCH_INTERVAL_MS,
    enabled: options?.enabled,
  });
};
